import { Component, computed, input, model, output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { IdentityVerificationStatus, UserIdentityDto } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '../../edit-wrapper/form-edit-wrapper.component';
import { AuraPersonIdentityDisplayComponent } from '../display/person-identity-display.component';
import { AuraPersonIdentityFormComponent } from '../form/person-identity-form.component';

@Component({
  selector: 'aura-person-identity-edit',
  templateUrl: './person-identity-edit.component.html',
  imports: [
    MatDividerModule,
    AuraPersonIdentityFormComponent,
    AuraEditWrapperComponent,
    AuraPersonIdentityDisplayComponent,
  ],
})
export class AuraPersonIdentityEditComponent {
  initialIdentity = input.required<UserIdentityDto>();
  showMode = input<'all' | 'names' | 'demographics'>('all');
  isEditing = model<boolean>(false);
  identitySaved = output<UserIdentityDto>();

  currentIdentity = computed<UserIdentityDto>(() => this.initialIdentity());
  IdentityVerificationStatus = IdentityVerificationStatus;

  isEditable = computed(() => {
    if (this.showMode() === 'demographics') return true;
    return (
      this.currentIdentity()?.verificationStatus !== IdentityVerificationStatus.VERIFIED &&
      this.currentIdentity()?.verificationStatus !== IdentityVerificationStatus.REVIEW_REQUIRED
    );
  });
}
